<template>
  <a
    class="nav-link-item"
    :class="{sub}"
    @click="replace()"
  >
    <span @touchstart="report(nav.targetRouterName, nav.name)">
      {{ nav.name }}</span>
  </a>
</template>

<script>

export default {
  props: {
    // 是否为顶部二级导航
    sub: {
      type: Boolean,
      default: false,
    },
    // 当前nav
    nav: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '', name: '' }),
    },
  },
  methods: {
    report(ename, cname) {
      PTTSendClick('btn', ename, cname);
    },
    replace() {
      this.$router.replace({
        name: this.nav.targetRouterName,
        params: { versions: this.nav.versions, id: this.$route.params.id },
      });
    } },
};
</script>

<style lang="scss" scoped>
.nav-link-item {
  position: relative;
}
</style>
